module.exports = __webpack_public_path__ + "img/art-40.052fb35b.png";